export const BASELINE_EMOJI = '😀'
